export default {
  methods: {
    notification(message, type, duration = 3000) {
      this.$buefy.notification.open({
        message: this.$translate(message),
        type,
        duration,
        queue: false,
      })
    },
    async dialog(title, message, cancelText, confirmText, cb) {
      this.$buefy.dialog.confirm({
        title: this.$translate(title),
        message: this.$translate(message),
        cancelText: this.$translate(cancelText),
        confirmText: this.$translate(confirmText),
        onConfirm: cb,
      })
    },
    getZipName() {
      const name = this.$store.getters.user.userInfo.name
      const surname = this.$store.getters.user.userInfo.surname
      return `${name}${surname}${new Date().toLocaleDateString()}.zip`
    },
    async getAttachmentExtension(storageRef, item) {
      const type = item.substring(item.length - 6, item.length - 3)
      if (type === 'pln') return 'pln'
      if (type === 'fms') return 'fms'
      if (type === 'stl' || type === 'una') return 'stl'
      const meta = await storageRef.getMetadata()
      if (meta.substring(meta.length - 3) === 'peg') return 'jpeg'
      return meta
    },
  },
}
